import * as constants from "./constants";

export const fetchCategories = (data) => {
  return {
    type: constants.FETCH_CATEGORIES,
    data,
  };
};

export const fetchCategoriesSuccess = (data) => {
  return {
    type: constants.FETCH_CATEGORIES_SUCCESS,
    data: data,
  };
};

export const fetchCategoriesError = (data) => {
  return {
    type: constants.FETCH_CATEGORIES_ERROR,
    data: data,
  };
};

export const createCategories = (data, id) => {
  return {
    type: constants.CREATE_CATEGORIES,
    data: data,
  };
};

export const createCategoriesSuccess = (data) => {
  return {
    type: constants.CREATE_CATEGORIES_SUCCESS,
    data: data,
  };
};

export const createCategoriesError = (id) => {
  return {
    type: constants.CREATE_CATEGORIES_ERROR,
    id,
  };
};

export const updateCategories = (payload) => ({
  type: constants.UPDATE_CATEGORIES,
  payload,
});

export const updateCategoriesSuccess = (data) => {
  return {
    type: constants.UPDATE_CATEGORIES_SUCCESS,
    data: data,
  };
};
export const updateCategoriesError = () => {
  return {
    type: constants.UPDATE_CATEGORIES_ERROR,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};

export const setStorage = (data) => {
  return {
    type: constants.SET_BADGES_MANAGER_STATE,
    data,
  };
};
